import { render } from "./immigrantFrom.vue?vue&type=template&id=ee551e28&scoped=true"
import script from "./immigrantFrom.vue?vue&type=script&lang=js"
export * from "./immigrantFrom.vue?vue&type=script&lang=js"

import "./immigrantFrom.vue?vue&type=style&index=0&id=ee551e28&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee551e28"]])

export default __exports__